import { TriangleAlert } from 'lucide-react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';

/** Catches render and lazy-load errors (e.g. a stale chunk after a deploy). */
export function RouteErrorPage() {
  const error = useRouteError();
  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : 'Something went wrong';

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas p-4">
      <Card className="w-full max-w-lg">
        <EmptyState
          icon={TriangleAlert}
          title={title}
          description="Reload the page to try again. If it keeps happening, contact support."
        />
        <div className="flex justify-center pb-4">
          <Button onClick={() => window.location.reload()}>Reload</Button>
        </div>
      </Card>
    </div>
  );
}
